// pages/CouleurMarque/CouleurMarque.jsx
import React, { useCallback, useState } from 'react'
import { message, Spin, Row, Col, Card, Statistic } from "antd";
import { ShoppingCartOutlined, StarOutlined, CheckCircleOutlined } from '@ant-design/icons';
import JournalHeader from '../journalHeader/JournalHeader';
import FilterJournalStock from '../filterJournalStock/FilterJournalStock';
import Couleurs from './couleurs/Couleurs';
import Marques from './marques/Marques';
import TypesChaussure from './typesChaussure/TypesChaussure';
import './couleurMarque.scss';
import useCouleurMarqueData from './hooks/useCouleurMarqueData';

const CouleurMarque = () => {
    const { 
        data,
        loading,
        filters,
        fetchDatas,
        refreshWithFilters
    } = useCouleurMarqueData();

    const [currentFilters, setCurrentFilters] = useState({
        id_marque: null,
        id_taille: null,
        date_debut: null,
        date_fin: null
    });

    const handleFilter = useCallback((filters) => {
        if (filters.date_debut && filters.date_fin && 
            new Date(filters.date_debut) > new Date(filters.date_fin)) {
            message.error("La date de début doit être antérieure à la date de fin");
            return;
        }
        
        setCurrentFilters(filters);
        refreshWithFilters(filters);
    }, [refreshWithFilters]);

    // Calcul des statistiques globales
    const totalVentes = data.top_couleurs?.reduce((acc, d) => acc + (d.quantite_vendue || 0), 0) || 0;
    const topCouleur = data.top_couleurs?.[0]?.couleur || '-';
    const topMatiere = data.top_matieres?.[0]?.matiere || '-';
    const nbRecommandations = data.recommandations_achat?.length || 0;

    return (
        <div className="couleur_marque">
            <JournalHeader title="Couleurs, Matières et Types" />
            <div className="couleur_marque_container">
                <FilterJournalStock onSearch={handleFilter} />
                
                <Spin spinning={loading}>
                    <div className="couleur_marque_wrapper">
                        <Row gutter={[16, 16]} className="stats-overview">
                            <Col xs={24} sm={6}>
                                <Card className="stats-card">
                                    <Statistic 
                                        title="Total Ventes" 
                                        value={totalVentes} 
                                        prefix={<ShoppingCartOutlined />}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} sm={6}>
                                <Card className="stats-card">
                                    <Statistic 
                                        title="Top Couleur" 
                                        value={topCouleur} 
                                        prefix={<StarOutlined />}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} sm={6}>
                                <Card className="stats-card">
                                    <Statistic 
                                        title="Top Matière" 
                                        value={topMatiere} 
                                        prefix={<StarOutlined />}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} sm={6}>
                                <Card className="stats-card">
                                    <Statistic 
                                        title="Recommandations" 
                                        value={nbRecommandations} 
                                        prefix={<CheckCircleOutlined />}
                                    />
                                </Card>
                            </Col>
                        </Row>

                        <div className="couleur_marque_grid">
                            <Couleurs data={data.top_couleurs} loading={loading} />
                            <Marques data={data.top_matieres} loading={loading} />
                            <TypesChaussure data={data.top_categories} loading={loading} />
                        </div>

                        {data.analyse_croisee && data.analyse_croisee.length > 0 && (
                            <Card className="cross-analysis" title="🔗 Analyse Croisée Couleur × Matière">
                                <Row gutter={[16, 16]}>
                                    {data.analyse_croisee.slice(0, 6).map((item, index) => (
                                        <Col xs={24} sm={12} md={8} key={index}>
                                            <Card size="small" className="cross-card">
                                                <div className="cross-item">
                                                    <span className="cross-couleur">{item.couleur}</span>
                                                    <span className="cross-matiere">× {item.matiere}</span>
                                                </div>
                                                <div className="cross-stats">
                                                    <span>Ventes: {item.quantite_vendue || 0}</span>
                                                    <span>Prix: {Number(item.prix_moyen || 0).toLocaleString()} $</span>
                                                </div>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Card>
                        )}
                    </div>
                </Spin>
            </div>
        </div>
    );
};

export default CouleurMarque;